export default "__VITE_ASSET__3aaa721b__"